import { handleActions } from 'redux-actions';

import initialState from 'state/status/initial.state';
import actions from 'state/status/actionCreators';

const status = handleActions(
  {
    [actions.setStatus]: (state, { payload: status }) => ({
      ...state,
      status,
    }),
    [actions.setIncreaseNumberOfFailures]: (state) => ({
      ...state,
      consecutive_failures: state.consecutive_failures + 1,
    }),
    [actions.setResetNumberOfFailures]: (state) => ({
      ...state,
      consecutive_failures: 0,
    }),
  },
  initialState
);

export default status;
